export const OPERATOR_LABELS = {
  IS: 'is',
  IS_NOT: 'is not',
  IS_ANY: 'is any of',
  IS_NOT_ANY: 'is not any of',
  CONTAINS_EXACT: 'contains',
  DOES_NOT_CONTAIN_EXACT: 'does not contain',
  STARTS_WITH: 'starts with',
  DOES_NOT_START_WITH: 'does not start with',
  ENDS_WITH: 'ends with',
  DOES_NOT_END_WITH: 'does not end with',
  IS_PRESENT: 'is present.',
  IS_NOT_PRESENT: 'is not present.',
  GTE: 'is greater than or equal to',
  LTE: 'is less than or equal to',
  GT: 'is greater than',
  LT: 'is less than',
  BETWEEN: 'is between',
  NOT_BETWEEN: 'is not between',
  WITHIN_DISTANCE: 'is within', //VALUE: { TYPE: UNIT, VALUE: { UNIT: KM, VALUE: 123 }}
  NOT_WITHIN_DISTANCE: 'is not within',
  IS_BEFORE: 'is before',
  IS_NOT_BEFORE: 'is not before',
  IS_AFTER: 'is after',
  IS_NOT_AFTER: 'is not after',
  RELATIVE_DATE_FILTER: 'is within'
}
